<div  class="footer layout-corral">
    <a href="https://vniigaz-cert.ru/" target="_blank">
      © 2023, Газпром ВНИИГАЗ
    </a>
    <div>
      142717,&nbsp;Московская&nbsp;область, г.о.&nbsp;Ленинский,&nbsp;п.&nbsp;Развилка, ул.&nbsp;Газовиков,&nbsp;зд.&nbsp;15,&nbsp;стр.&nbsp;1
    </div>
    <div></div>
    <a href="https://nirgroup.ru/" class="footer-nir" target="_blank">
      Работает на платформе НИР
    </a>
</div>